import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e50cf92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { class: "codebites-wrapper" }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelService from '@/services/ChannelService'
import { onMounted, ref,Ref } from 'vue';
import CodeBite from '@/components/cards/CodeBite.vue'
import ProfileService from '@/services/ProfileService'
import { useRoute } from 'vue-router';
import router from '@/router';
import CodeI from '@/interfaces/CodeBiteInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeBiteAll',
  setup(__props) {

const service = new ChannelService()
const items:Ref<CodeI[]> = ref([])
const filtered:Ref<CodeI[]> = ref([])
const loading = ref(false)
const search = ref('')
const profileService = new ProfileService()
const user = ref()
const route = useRoute()
const nickname = route.params.nickname

onMounted(async () => {
    loading.value = true
    user.value = await profileService.GetUserByNickname(nickname)
    items.value = await service.GetLatestCodeBites(user.value.id, 1000000)
    filtered.value = items.value
    loading.value = false
})
const goBack = () => {
    router.back()
}
const refresh = async () => {
    items.value = await service.GetLatestCodeBites(user.value.id, 1000000)
    filtered.value = items.value
}

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter(item => item?.title?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, "Shorts de " + _toDisplayString(_unref(nickname)), 1),
            _createElementVNode("button", {
              class: "new-question",
              onClick: goBack
            }, "Volver Atrás"),
            _hoisted_3,
            _createElementVNode("form", _hoisted_4, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar por título.",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                return (_openBlock(), _createBlock(CodeBite, {
                  key: item.id,
                  codebite: item,
                  user: user.value,
                  onRefresh: refresh
                }, null, 8, ["codebite", "user"]))
              }), 128))
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})